"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehicleFeedDiagnosticsResponseSchema = exports.vehicleFeedDeltaResponseSchema = exports.vehicleMapFeedDtoSchema = exports.vehicleFeedQuerySchema = exports.vehicleFeedBboxSchema = exports.vehicleSchema = exports.vehicleAlertProfileSchema = exports.vehicleFuelProfileSchema = exports.vehicleComplianceSchema = exports.vehicleMaintenanceSchema = exports.vehicleOperationsSchema = exports.vehicleDriverAssignmentsSchema = exports.vehicleDeviceProfileSchema = exports.vehicleRegistrationSchema = exports.vehicleFlagsSchema = exports.vehicleSensorSchema = exports.vehicleMediaSchema = exports.vehicleDriverSchema = exports.vehicleLocationSchema = exports.vehicleUsageSchema = exports.rasterMarkerTypeSchema = exports.vehicleAssetTypeSchema = exports.vehicleStatusSchema = void 0;
const zod_1 = require("zod");
exports.vehicleStatusSchema = zod_1.z.enum([
    "running",
    "stationary",
    "stopped",
    "inactive",
    "no_gps",
    "offline",
    "maintenance",
    "commissioning",
]);
exports.vehicleAssetTypeSchema = zod_1.z.enum([
    "sedan",
    "suv",
    "pickup",
    "van",
    "truck",
    "motorcycle",
    "bus",
    "tractor",
    "trailer",
    "other",
    "light_vehicle",
    "heavy_vehicle",
    "reefer",
    "yellow_machine",
    "generator",
    "asset",
]);
exports.rasterMarkerTypeSchema = zod_1.z.enum(["sedan", "truck", "bike"]);
exports.vehicleUsageSchema = zod_1.z.object({
    purpose: zod_1.z.string().optional(),
    businessUnit: zod_1.z.string().optional(),
    costCenter: zod_1.z.string().optional(),
    projectCodes: zod_1.z.array(zod_1.z.string()).optional(),
    tags: zod_1.z.array(zod_1.z.string()).optional(),
});
exports.vehicleLocationSchema = zod_1.z.object({
    lat: zod_1.z.number(),
    lng: zod_1.z.number(),
    heading: zod_1.z.number().optional(),
    altitude: zod_1.z.number().optional(),
});
exports.vehicleDriverSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    phone: zod_1.z.string().optional(),
    allocated: zod_1.z.boolean().optional(),
    avatarUrl: zod_1.z.string().url().optional(),
    email: zod_1.z.string().email().optional(),
    licenseNumber: zod_1.z.string().optional(),
    licenseExpiry: zod_1.z.string().optional(),
    certifications: zod_1.z.array(zod_1.z.string()).optional(),
});
exports.vehicleMediaSchema = zod_1.z.object({
    primaryImageUrl: zod_1.z.string().url().optional(),
    gallery: zod_1.z.array(zod_1.z.string().url()).optional(),
    dashcamChannelIds: zod_1.z.array(zod_1.z.string()).optional(),
    lastCalibratedAt: zod_1.z.string().optional(),
});
exports.vehicleSensorSchema = zod_1.z.object({
    fuelLevelPct: zod_1.z.number().min(0).max(100).optional(),
    batteryVoltage: zod_1.z.number().optional(),
    engineTempC: zod_1.z.number().optional(),
    rpm: zod_1.z.number().optional(),
    odometerKm: zod_1.z.number().optional(),
    speedKph: zod_1.z.number().optional(),
    coolantTempC: zod_1.z.number().optional(),
    tirePressureKpa: zod_1.z.record(zod_1.z.string(), zod_1.z.number()).optional(),
    cargoTempC: zod_1.z.number().optional(),
    doorOpen: zod_1.z.boolean().optional(),
});
exports.vehicleFlagsSchema = zod_1.z.object({
    mechanic: zod_1.z.boolean().optional(),
    immobilized: zod_1.z.boolean().optional(),
    gpsLock: zod_1.z.boolean().optional(),
    harshEvent: zod_1.z.boolean().optional(),
    panicAlert: zod_1.z.boolean().optional(),
    complianceHold: zod_1.z.boolean().optional(),
});
exports.vehicleRegistrationSchema = zod_1.z
    .object({
    regNo: zod_1.z.string().optional(),
    vin: zod_1.z.string().optional(),
    make: zod_1.z.string().optional(),
    model: zod_1.z.string().optional(),
    year: zod_1.z.number().optional(),
    variant: zod_1.z.string().optional(),
    bodyStyle: zod_1.z.string().optional(),
    drivetrain: zod_1.z.string().optional(),
    color: zod_1.z.string().optional(),
    acquisitionDate: zod_1.z.string().optional(),
    warrantyExpiry: zod_1.z.string().optional(),
})
    .partial();
exports.vehicleDeviceProfileSchema = zod_1.z
    .object({
    deviceId: zod_1.z.string().optional(),
    imei: zod_1.z.string().optional(),
    serialNumber: zod_1.z.string().optional(),
    vendor: zod_1.z.string().optional(),
    model: zod_1.z.string().optional(),
    firmware: zod_1.z.string().optional(),
    status: zod_1.z.enum(["active", "inactive", "decommissioned", "maintenance"]).optional(),
    heartbeatSeconds: zod_1.z.number().optional(),
    lastOnlineAt: zod_1.z.string().optional(),
    signalStrength: zod_1.z.number().optional(),
    sim: zod_1.z
        .object({
        iccid: zod_1.z.string().optional(),
        carrier: zod_1.z.string().optional(),
        plan: zod_1.z.string().optional(),
        apn: zod_1.z.string().optional(),
    })
        .optional(),
    connectivity: zod_1.z
        .object({
        networkType: zod_1.z.string().optional(),
        lastRssi: zod_1.z.number().optional(),
        ipAddress: zod_1.z.string().optional(),
    })
        .optional(),
    ioMappings: zod_1.z.array(zod_1.z.object({ channel: zod_1.z.string(), label: zod_1.z.string().optional() })).optional(),
    sensors: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
})
    .partial();
exports.vehicleDriverAssignmentsSchema = zod_1.z
    .object({
    primary: exports.vehicleDriverSchema.optional(),
    secondary: exports.vehicleDriverSchema.optional(),
    crew: zod_1.z.array(exports.vehicleDriverSchema).optional(),
    lastHandOverAt: zod_1.z.string().optional(),
})
    .partial();
exports.vehicleOperationsSchema = zod_1.z
    .object({
    homeBase: zod_1.z.string().optional(),
    organisation: zod_1.z.object({ id: zod_1.z.string(), name: zod_1.z.string() }).optional(),
    currentRouteId: zod_1.z.string().optional(),
    assignedRoutes: zod_1.z.array(zod_1.z.object({ id: zod_1.z.string(), name: zod_1.z.string().optional(), schedule: zod_1.z.string().optional() })).optional(),
    geofencePolicies: zod_1.z.array(zod_1.z.string()).optional(),
    lastTrip: zod_1.z
        .object({
        startedAt: zod_1.z.string().optional(),
        endedAt: zod_1.z.string().optional(),
        distanceKm: zod_1.z.number().optional(),
        durationMinutes: zod_1.z.number().optional(),
        score: zod_1.z.number().optional(),
    })
        .optional(),
})
    .partial();
exports.vehicleMaintenanceSchema = zod_1.z
    .object({
    odometerKm: zod_1.z.number().optional(),
    engineHours: zod_1.z.number().optional(),
    serviceIntervalKm: zod_1.z.number().optional(),
    nextServiceAtKm: zod_1.z.number().optional(),
    nextServiceDue: zod_1.z.string().optional(),
    activeTickets: zod_1.z.array(zod_1.z.string()).optional(),
    maintenanceHistory: zod_1.z.array(zod_1.z.object({ id: zod_1.z.string(), title: zod_1.z.string(), completedAt: zod_1.z.string().optional() })).optional(),
})
    .partial();
exports.vehicleComplianceSchema = zod_1.z
    .object({
    registration: exports.vehicleRegistrationSchema.optional(),
    insurance: zod_1.z
        .object({
        policyNumber: zod_1.z.string().optional(),
        provider: zod_1.z.string().optional(),
        coverage: zod_1.z.string().optional(),
        validFrom: zod_1.z.string().optional(),
        validTo: zod_1.z.string().optional(),
    })
        .optional(),
    documents: zod_1.z
        .array(zod_1.z.object({
        id: zod_1.z.string(),
        name: zod_1.z.string(),
        type: zod_1.z.string().optional(),
        url: zod_1.z.string().optional(),
        expiresAt: zod_1.z.string().optional(),
    }))
        .optional(),
    audits: zod_1.z
        .array(zod_1.z.object({
        id: zod_1.z.string(),
        name: zod_1.z.string(),
        status: zod_1.z.string().optional(),
        completedAt: zod_1.z.string().optional(),
    }))
        .optional(),
})
    .partial();
exports.vehicleFuelProfileSchema = zod_1.z
    .object({
    fuelType: zod_1.z.string().optional(),
    tankCapacityL: zod_1.z.number().optional(),
    averageConsumptionLPer100Km: zod_1.z.number().optional(),
    lastFuelEntry: zod_1.z
        .object({
        filledAt: zod_1.z.string().optional(),
        volumeLiters: zod_1.z.number().optional(),
        vendor: zod_1.z.string().optional(),
    })
        .optional(),
    consumptionTrends: zod_1.z.array(zod_1.z.object({ period: zod_1.z.string(), lPer100Km: zod_1.z.number().optional() })).optional(),
})
    .partial();
exports.vehicleAlertProfileSchema = zod_1.z
    .object({
    activeAlerts: zod_1.z.array(zod_1.z.object({ id: zod_1.z.string(), type: zod_1.z.string(), severity: zod_1.z.string().optional(), raisedAt: zod_1.z.string().optional() })).optional(),
    automationPolicies: zod_1.z.array(zod_1.z.string()).optional(),
    thresholds: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
})
    .partial();
exports.vehicleSchema = zod_1.z.object({
    id: zod_1.z.string(),
    number: zod_1.z.string().optional(),
    name: zod_1.z.string(),
    assetType: exports.vehicleAssetTypeSchema.optional(),
    rasterMarkerType: exports.rasterMarkerTypeSchema.optional(),
    usage: exports.vehicleUsageSchema.optional(),
    status: exports.vehicleStatusSchema.optional(),
    lastPing: zod_1.z.string().optional(),
    location: exports.vehicleLocationSchema.optional(),
    drivers: exports.vehicleDriverAssignmentsSchema.optional(),
    sensors: exports.vehicleSensorSchema.optional(),
    flags: exports.vehicleFlagsSchema.optional(),
    registration: exports.vehicleRegistrationSchema.optional(),
    media: exports.vehicleMediaSchema.optional(),
    device: exports.vehicleDeviceProfileSchema.optional(),
    operations: exports.vehicleOperationsSchema.optional(),
    maintenance: exports.vehicleMaintenanceSchema.optional(),
    compliance: exports.vehicleComplianceSchema.optional(),
    fuel: exports.vehicleFuelProfileSchema.optional(),
    alerts: exports.vehicleAlertProfileSchema.optional(),
    createdAt: zod_1.z.string().optional(),
    updatedAt: zod_1.z.string().optional(),
});
exports.vehicleFeedBboxSchema = zod_1.z.object({
    minLng: zod_1.z.number(),
    minLat: zod_1.z.number(),
    maxLng: zod_1.z.number(),
    maxLat: zod_1.z.number(),
});
exports.vehicleFeedQuerySchema = zod_1.z.object({
    tenantId: zod_1.z.string().optional(),
    organizationId: zod_1.z.string().optional(),
    fleetId: zod_1.z.string().optional(),
    ownerUserId: zod_1.z.string().optional(),
    bbox: zod_1.z.string().optional(), // minLng,minLat,maxLng,maxLat
    since: zod_1.z.string().optional(),
    zoom: zod_1.z.number().int().optional(),
    limit: zod_1.z.number().int().positive().optional(),
    mode: zod_1.z.enum(["full", "delta"]).optional(),
});
exports.vehicleMapFeedDtoSchema = zod_1.z.object({
    id: zod_1.z.string(),
    plate: zod_1.z.string().optional(),
    regNo: zod_1.z.string().optional(),
    number: zod_1.z.string().optional(),
    vin: zod_1.z.string().optional(),
    name: zod_1.z.string(),
    assetType: zod_1.z.string().optional(),
    color: zod_1.z.string().optional(),
    rasterMarkerType: exports.rasterMarkerTypeSchema.optional(),
    status: zod_1.z.enum(["online", "stationary", "stopped"]),
    rawStatus: zod_1.z.string().optional(),
    speedKph: zod_1.z.number(),
    rpm: zod_1.z.number().optional(),
    signalStrength: zod_1.z.number().optional(),
    batteryLevel: zod_1.z.number().optional(),
    batteryVoltage: zod_1.z.number().optional(),
    fuelLevelPct: zod_1.z.number().optional(),
    odometerKm: zod_1.z.number().optional(),
    engineHours: zod_1.z.number().optional(),
    tripCount: zod_1.z.number().optional(),
    sensors: zod_1.z
        .object({
        speedKph: zod_1.z.number().optional(),
        rpm: zod_1.z.number().optional(),
        signalStrength: zod_1.z.number().optional(),
        batteryLevel: zod_1.z.number().optional(),
        batteryVoltage: zod_1.z.number().optional(),
        fuelLevelPct: zod_1.z.number().optional(),
        odometerKm: zod_1.z.number().optional(),
        engineHours: zod_1.z.number().optional(),
        altitudeMeters: zod_1.z.number().optional(),
        lastPing: zod_1.z.string().optional(),
    })
        .optional(),
    lastPing: zod_1.z.string().optional(),
    location: exports.vehicleLocationSchema.optional(),
    flags: zod_1.z.object({
        gps: zod_1.z.boolean(),
        driverAssigned: zod_1.z.boolean(),
        fuelLow: zod_1.z.boolean(),
        mechFault: zod_1.z.boolean(),
        immobilized: zod_1.z.boolean(),
    }),
    driver: exports.vehicleDriverSchema.optional(),
    device: zod_1.z.object({
        imei: zod_1.z.string().optional(),
        protocol: zod_1.z.string().optional(),
        lastSeen: zod_1.z.string().optional(),
    }).optional(),
    ageMs: zod_1.z.number().optional(),
    ageMinutes: zod_1.z.number().optional(),
    stale: zod_1.z.boolean().optional(),
    hasValidCoords: zod_1.z.boolean().optional(),
    feedTimestamp: zod_1.z.string().optional(),
    gpsFixTs: zod_1.z.string().optional(),
    ingestTs: zod_1.z.string().optional(),
    geofenceStatus: zod_1.z.string().optional(),
    geofenceId: zod_1.z.string().optional(),
    headingOffsetDeg: zod_1.z.number().optional(),
});
exports.vehicleFeedDeltaResponseSchema = zod_1.z.object({
    mode: zod_1.z.literal("delta"),
    generatedAt: zod_1.z.string(),
    since: zod_1.z.string().optional(),
    vehicles: zod_1.z.array(exports.vehicleMapFeedDtoSchema),
});
exports.vehicleFeedDiagnosticsResponseSchema = zod_1.z.object({
    generatedAt: zod_1.z.string(),
    total: zod_1.z.number(),
    withValidCoords: zod_1.z.number(),
    staleCount: zod_1.z.number(),
    movingCount: zod_1.z.number(),
    staleThresholdMinutes: zod_1.z.number(),
    reasons: zod_1.z.object({
        noLocation: zod_1.z.number(),
        stale: zod_1.z.number(),
        stopped: zod_1.z.number(),
    }),
});
